import { useContext } from 'react';

import { AuthContext } from 'src/compass/site/providers';
import {
  AdministrationMenu,
  CommissionsMenu,
  EndorsementsMenu,
  RiskManagementMenu,
  UtilitiesMenu,
} from './menus';
import { ITabRoutes } from '../util/TabListToRouteList';
import { hasCrudPermission } from './useUserHasPermission';

export type SubMenu = {
  title: string;
  path: string;
  element: React.ReactElement;
  permission: string;
  hidden?: boolean;
  children?: ITabRoutes[];
};

export type Menu = {
  menuTitle: string;
  path: string;
  icon?: React.ReactElement;
  subMenus: SubMenu[];
};

const menus: Menu[] = [
  ...RiskManagementMenu,
  ...EndorsementsMenu,
  ...CommissionsMenu,
  ...UtilitiesMenu,
  ...AdministrationMenu,
];



export function useCasFilteredNavigation() {
  const { userPermissions } = useContext(AuthContext);

  const filteredMenu = menus
    .map((section) => ({
      ...section,
      subMenus: section.subMenus
        .filter((subMenu) => hasCrudPermission(userPermissions || [], subMenu.permission))
        .map((subMenu) => {
          const fullPath = `/${section.path}/${subMenu.path}`;
          return {
            ...subMenu,
            path: fullPath, 
          };
      }),
    }))
    .filter((section) => section.subMenus.length > 0); // Filter out sections with no subMenus

  return filteredMenu;
}
